import Vue from 'vue'
import './store/mixin';
import './store/call.mixin';
import './store/lead.mixin';
import store from './store/store';
import router from './store/router';
import app from './App';
import VueLodash from 'vue-lodash'
import groupBy from 'lodash/groupBy'
import Fragment from 'vue-fragment'
import VueMoment from 'vue-moment'
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use( CKEditor );
Vue.use(Fragment.Plugin)
Vue.use(VueMoment);
Vue.use(VueLodash, { name: 'custom', lodash: { groupBy } })

setTimeout(() => {
  const main = document.querySelector('.app-vue');
  if (main) {
    window.$vue = new Vue({
      el: main,
      render: h => h(app),
      store,
      router,
    });
  }
}, 0);

export default () => {
    return {app, store, router}
};
